import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { PageHero, Reveal } from "@/components/site/Reveal";
import { PRESTATIONS, pageOf } from "@/data/site";
import usePageMeta from "@/hooks/usePageMeta";

export default function Prestations() {
  usePageMeta("Nos services de conciergerie à Brest", "Tous les services de Conciergerie Familly 29 à Brest : visites de surveillance, ouverture et fermeture, entretien, linge, accueil, petites réparations et coordination d'artisans.");
  return (
    <>
      <PageHero testid="prestations-hero" eyebrow="Nos prestations" title="Nos services de conciergerie à Brest" text="Des services adaptés aux propriétaires absents, aux militaires en mission et aux résidences secondaires, à Brest et dans ses environs." image="/images/cles.jpg" />
      <section className="mx-auto max-w-7xl space-y-6 px-5 py-24 lg:px-8">
        {PRESTATIONS.map((p, i) => (
          <Reveal key={p.slug}>
            <article data-testid={`prestation-${p.slug}`} className="grid overflow-hidden rounded-lg border border-[#0F2840]/10 bg-white md:grid-cols-12">
              <div className={`relative h-56 md:col-span-5 md:h-auto ${i % 2 ? "md:order-2" : ""}`}>
                <img src={p.image} alt={`${p.nom} – Conciergerie Familly 29 à Brest`} className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
              </div>
              <div className="p-8 md:col-span-7 md:p-12">
                <div className="flex items-center gap-3">
                  <span className="grid h-11 w-11 place-items-center rounded-full bg-[#0F2840] text-white"><p.icon className="h-5 w-5" /></span>
                  <span className="text-xs font-bold text-slate-400">0{i + 1}</span>
                </div>
                <h2 className="mt-5 font-display text-2xl font-semibold md:text-3xl">{p.nom}</h2>
                <p className="mt-3 text-slate-600">{p.court}</p>
                <ul className="mt-6 grid gap-2 text-sm sm:grid-cols-2">
                  {p.details.map((d) => <li key={d} className="flex gap-2"><Check className="mt-0.5 h-4 w-4 text-[#D82C2C]" />{d}</li>)}
                </ul>
                <div className="mt-8 flex flex-wrap gap-5">
                  <Link to={pageOf(p.slug)} data-testid={`prestation-page-${p.slug}`} className="inline-flex items-center gap-1 text-sm font-bold text-[#0F2840] hover:underline">En savoir plus</Link>
                  <Link to={`/devis?prestation=${encodeURIComponent(p.nom)}`} data-testid={`prestation-devis-${p.slug}`} className="inline-flex items-center gap-1 text-sm font-bold text-[#D82C2C] hover:underline">
                    Demander un devis <ArrowRight className="h-4 w-4" />
                  </Link>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </section>
    </>
  );
}
